import bigcityLogo from './picture/bigcity-logo.svg'
import facebook from './icons/facebook.svg'
import twitter from './icons/Twitter.svg'
import linkedin from './icons/Linkedin.svg'
import search from './icons/search.svg'
import closeIcon from './icons/close.svg';
import otp from './icons/otp.svg';
import accunt from './icons/account.svg';
import congrat from './icons/congratulation.svg';
import plus from './icons/plus.svg'
import xmark from './icons/xmark.svg';
import phoneCall from './icons/phone-call.svg';
import mail from './icons/email.svg';
import location from './icons/location-filled.svg';
import insta from './icons/insta.svg';
import twit from './icons/twitter-blue.svg';
import game from './icons/game.svg';
import OnboardLeft from './picture/onboard-left.svg'
import RadioSelected from './picture/Radio-selected.svg'
import Radio from './picture/readio.svg'
import Loader from './picture/loader.webp'
import noDataFound from './picture/noDataFound.svg'
import logo from './picture/logo.svg'
import userimage from './picture/userImage.png'
import finalLogo from './picture/Final-logo.png'

export const IMAGES = {
    bigcityLogo: bigcityLogo,
    twitter: twitter,
    linkedin: linkedin,
    facebook: facebook,
    search: search,
    closeIcon: closeIcon,
    otp: otp,
    accunt: accunt,
    congrat: congrat,
    plus: plus,
    xmark: xmark,
    phoneCall: phoneCall,
    mail: mail,
    game: game,
    locaiton: location,
    twit: twit,
    insta: insta,
    OnboardLeft: OnboardLeft,
    RadioSelected: RadioSelected,
    Radio: Radio,
    Loader: Loader,
    noDataFound: noDataFound,
    logo: logo,
    finalLogo: finalLogo,
    userimage: userimage,

};
